<template>
  <div style="background-color: #F8F8F8;min-height: calc(100vh - 60px);">
    <div class="container" style="padding-top: 100px;" v-if="page">
      <div class="row">
        <div class="col-sm-12">
          <div class="blog-single">
            <div class="blog-box blog-details">
              <div class="blog-details">

                <h4>
                  {{page.translation[0].name}}
                </h4>
                <ul class="blog-social">
                  <li class="digits">{{ page.created_at | moment("MM/DD/YYYY") }}</li>
                </ul>
                <div class="single-blog-content-top" v-html="page.translation[0].description"></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SinglePage',
  data() {
    return {
      page: null,
      show: true
    }
  },
  async mounted() {
    let res = await this.$store.dispatch('shared/getPage', this.$route.params.slug)
    this.page = res.data.result
  }
}
</script>